const questions = [
]
export default {
  label:"JS Object Overview",
  link:"/javaScript_object_tutorial",
  questions,
  tutorial_link:"http://xahlee.info/js/js_JavaScript_object_tutorial.html"
}



/** WEBPACK FOOTER **
 ** ./src/questions/04_object_inheritance/01_object_overview.js
 **/